/**
 * @file Renders an import's row errors as a labeled list.
 */
import React from "react";
import { Alert, List, Space, Typography } from "antd";

import type { ImportError } from "./types";

type Props = {
  title: string;
  errors: ImportError[];
  prefix: string;
};

/**
 * Renders the import's errors as a titled list, one row prefix and reason
 * per item.
 */
const ImportModalErrors = ({
  title,
  errors,
  prefix,
}: Props): JSX.Element => {
  return (
    <Alert
      type="error"
      message={title}
      closable={false}
      description={
        <List
          size="small"
          dataSource={errors}
          itemLayout="vertical"
          renderItem={(item: ImportError) =>
            (
              <List.Item style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Space>
                  <Typography.Text type="secondary">
                    {`${prefix}${item.index}`}
                  </Typography.Text>
                  <Typography.Text>
                    {item.reason}
                  </Typography.Text>
                </Space>
              </List.Item>
            )
          }
        />
      }
    />
  );
};

export default ImportModalErrors;
export type { ImportError };
